import React from 'react';

const PresenterThankYou = () => {
  return <div className="flex-center">Thank you!</div>;
};

export default PresenterThankYou;
